import React, { FC, Fragment, useState, useEffect, useRef } from "react";
import { Route, Redirect, useHistory, Link, useParams } from 'react-router-dom';
import Label from "components/Label/Label";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import ProgressBar from 'react-customizable-progressbar';
import SectionTierCardSlider from "components/SectionTierCardSlider/SectionTierCardSlider";
import { Helmet } from "react-helmet";
import axios from 'axios';

import Collapsible from 'react-collapsible';

export interface OurRewordsPageProps {
  className?: string;
  autoFocus?: boolean;
}

const OurRewords: FC<OurRewordsPageProps> = ({
  className = "",
  autoFocus = false
}) => {
  const history = useHistory();
  const [totalRewardPoints, setTotalRewardPoints] = useState("");
  const [tierFirst, settierFirst] = useState(0);
  const [activeTab, setActiveTab] = useState<"available" | "notAvailable">("available");
  const [loading, setLoading] = useState(false);


  const sdfdsfd = [
    {

      "tier_name": "Up to 10.00%",
      "tier_image": "https://pictures.tinyaway.com/triers/tier1.svg"
    },
    {

      "tier_name": "Up to 10.00%",
      "tier_image": "https://pictures.tinyaway.com/triers/tier1.svg"
    },
    {

      "tier_name": "Up to 10.00%",
      "tier_image": "https://pictures.tinyaway.com/triers/tier1.svg"
    }
  ]
  useEffect(() => {
    axios.get(process.env.REACT_APP_BASE_URL + 'getUserRewards?user_id=')
      .then(res => {
        setTotalRewardPoints(res.data.rewards.points);
        settierFirst(res.data.rewards.tier);
      })
  })

  const renderRewards = () => {
    return (
      <>
        <div className="box-tranform box-shadow-card">
          <div className="card-Rewards Explorer">
            <div className="ProgressBar">
              <div className="flex-ProgressBar">
                <div>
                  <ProgressBar
                    radius={100}
                    progress={tierFirst}
                    rotate={-180}
                    strokeWidth={10}
                    strokeColor="#df485f"
                    strokeLinecap="round"
                    trackStrokeWidth={10}
                    trackStrokeColor="#e6e6e6"
                    trackStrokeLinecap="square"
                    pointerRadius={-210}
                    initialAnimation={true}
                    transition="1.5s ease 0.5s"
                    trackTransition="0s ease"
                    counterClockwise
                  >
                    <div className="indicator">
                      {/* <p><b>KrisFlyer elite Silver</b></p> */}
                      <p className="color-light"></p>
                      <div className="color-w-prograsiv">{totalRewardPoints}</div>
                      <p className="color-light">points earned</p>
                    </div>
                  </ProgressBar>
                </div>
              </div>
              <div className="box-xx-points"><span></span><div>1350 more Tiny Away points to achieve Explorer status</div></div>
            </div>
          </div>
        </div>
      </>
    );
  }
  const renderMileStoneProgressBar = () => {
    return (
      <div className="vefs-milestone-wrapper">
        <div className="milestone-container">
          <div className="chart-container">
            <div className="line-container">
              <div className="line"></div>
              <div className="line left" style={{ width: "5%" }}></div>
            </div>
            <div className="dot-container">
              <div className="milestones milestone__10">
                <div className="dot completed colored"><i className=" las la-gift text-2xl "></i></div>
              </div>
              <div className="milestones milestone__25">
                <div className="dot completed colored"><i className=" las la-gift text-2xl "></i></div>
              </div>
              <div className="milestones milestone__50">
                <div className="dot completed colored"><i className=" las la-gift text-2xl "></i></div>
              </div>
              <div className="milestones milestone__80">
                <div className="dot"><i className=" las la-gift text-2xl "></i></div>
              </div>
            </div>
          </div>
          <div className="label-container">
            <div className="milestones milestone__10">
              <div className="label colored">500 Tiny Away Points <br /> $20 gift card</div>
            </div>
            <div className="milestones milestone__25">
              <div className="label colored">1000 Tiny Away Points<br /> $50 gift card</div>
            </div>
            <div className="milestones milestone__50">
              <div className="label colored">1500 Tiny Away Points<br />$100 gift card</div>
            </div>
            <div className="milestones milestone__80">
              <div className="label">2000 Tiny Away Points<br />$150 gift card</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  const AccountPageMidSection = () => {
    return (
      <div className="right-user-details-card">
        <div className="card pe-0">
          <div>
            <h4>How to level up</h4>
            <p className="mb-3">Get rewarded for exploring and enjoy exclusive deals</p>
          </div>
          <div className="reword-card-sr">
            <div className="flex justify-between reword-card-sleder">
              <div className="card card-border-1">
                <span className="start"><i className="las la-star"></i></span>
                <div className="text-reword-bold">600</div>
                <h5>Your Balance Points</h5>
                <p>Earn more points, redeem exciting gifts and enjoy thh experience</p>
                <div>
                  <a href="">Reward points history </a>
                  <a href=""> How to earn points?</a>
                  <a href=""> How does the loyalty program work?</a>
                </div>
              </div>
              <div className="w-70">
                <SectionTierCardSlider categories={sdfdsfd} itemPerRow={1} />
              </div>
            </div>
          </div>

          <div className="card-inner mt-12 padd-right-20">
            <h4 className="mt-5">Explore your Tier Benefits</h4>

            <div className="flex gap-3">
              <div className="card">
                <div className="icon-car-silver">
                  <img src="https://pictures.tinyaway.com/triers/TA_UIUX_RewardsBadge-27.svg" />
                </div>
                <h3>SILVER</h3>
                <p>Up to S$ 500 spend a year</p>
              </div>
              <div className="card">

                <h3>MEMBERSHIP BENEFITS</h3>
                <p>Welcome gift when you reach Silver Welcome offer on first booking 2x points on your birthday month Special birthday benefit.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="card mt-5">
          <h4>How to level up</h4>

          <div className="list-tab-account mt-5">
            <a
              href="javascript:void(0);"
              className={`tab ${activeTab === "available" ? "active" : ""}`}
              onClick={() => setActiveTab("available")}
            >
              Available
            </a>
            <a
              href="javascript:void(0);"
              className={`tab border-l ${activeTab === "notAvailable" ? "active" : ""}`}
              onClick={() => setActiveTab("notAvailable")}
            >
              Not Available
            </a>
          </div>

          {loading ? (
            <p>Loading...</p> // ✅ Show loading state while fetching
          ) : activeTab === "available" ? (
            <div>
              <div className="line"></div>
              <div className="card-color-row grid grid-cols-3 gap-4">
                <div className="card-color">
                  <h5>BOOK AND COMPLETE A STAY</h5>
                  <p>500 points</p>
                  <ButtonPrimary>GET POINTS</ButtonPrimary>
                </div>

                <div className="card-color">
                  <h5>BOOK AND COMPLETE A STAY</h5>
                  <p>500 points</p>
                  <ButtonPrimary>GET POINTS</ButtonPrimary>
                </div>

                <div className="card-color">
                  <h5>BOOK AND COMPLETE A STAY</h5>
                  <p>500 points</p>
                  <ButtonPrimary>GET POINTS</ButtonPrimary>
                </div>


                <div className="card-color">
                  <h5>BOOK AND COMPLETE A STAY</h5>
                  <p>500 points</p>
                  <ButtonPrimary>GET POINTS</ButtonPrimary>
                </div>

                <div className="card-color">
                  <h5>BOOK AND COMPLETE A STAY</h5>
                  <p>500 points</p>
                  <ButtonPrimary>GET POINTS</ButtonPrimary>
                </div>

                <div className="card-color">
                  <h5>BOOK AND COMPLETE A STAY</h5>
                  <p>500 points</p>
                  <ButtonPrimary>GET POINTS</ButtonPrimary>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="line"></div>
              <div className="row-history">
                <div className="flex justify-between">
                  <div>
                    <h5>YOU EARNED 100 POINTS!</h5>
                    <p>Refer a friend <br /> 20/5/24, 12:23 pm</p>
                  </div>
                  <div>
                    <span>+100</span>
                  </div>
                </div>

                <div className="flex justify-between">
                  <div>
                    <h5>YOU EARNED 100 POINTS!</h5>
                    <p>Refer a friend <br /> 20/5/24, 12:23 pm</p>
                  </div>
                  <div>
                    <span>+100</span>
                  </div>
                </div>

                <div className="flex justify-between">
                  <div>
                    <h5>YOU EARNED 100 POINTS!</h5>
                    <p>Refer a friend <br /> 20/5/24, 12:23 pm</p>
                  </div>
                  <div>
                    <span>+100</span>
                  </div>
                </div>

                <div className="flex justify-between">
                  <div>
                    <h5>YOU EARNED 100 POINTS!</h5>
                    <p>Refer a friend <br /> 20/5/24, 12:23 pm</p>
                  </div>
                  <div>
                    <span>+100</span>
                  </div>
                </div>

                <div className="flex justify-center border-0 mt-5">
                  <a href="">Show More</a>
                </div>

              </div>
            </div>
          )}
        </div>

        <div className="card mt-5 card-show-hiderbox">
          <h4 className="text-center">HOW DOES THE LOYALTY PROGRAM WORK ?</h4>
          <p>EARN POINTS: <br />$1 spent = 1 point earned</p>
          <p>SPEND POINTS   <br />Redeem 100 points = $10 Saving</p>
          <div className="max-w-700">
            <Collapsible trigger="HOW DO I REDEEM MY POINTS?" open={true}>
              <div className="grid grid-cols-1 xl:grid-cols-1 gap-2 text-sm text-neutral-700 dark:text-neutral-300 max-win-320">
                <div>
                  <div className="flex items-center space-x-3">
                    Make sure you are logged in first. Once you in your order review page during checkout, simply click on redeem points button to apply all available points to your order.
                    <br></br>
                    Please refer to this help article for how to redeem your points.
                  </div>
                </div>
              </div>
            </Collapsible>


            <Collapsible trigger="EARNING POINTS THROUGH WRITING PRODUCT REVIEWS" open={false} className="mt-2">
              <div className="grid grid-cols-1 xl:grid-cols-1 gap-2 text-sm text-neutral-700 dark:text-neutral-300 max-win-320">
                <div>
                  <div className="flex items-center space-x-3">
                    Make sure you are logged in first. Once you in your order review page during checkout, simply click on redeem points button to apply all available points to your order.
                    <br></br>
                    Please refer to this help article for how to redeem your points.
                  </div>
                </div>
              </div>
            </Collapsible>


            <Collapsible trigger="WHEN WILL MY REVIEW BE APPROVED? WHEN CAN I GET MY POINTS?" open={false} className="mt-2">
              <div className="grid grid-cols-1 xl:grid-cols-1 gap-2 text-sm text-neutral-700 dark:text-neutral-300 max-win-320">
                <div>
                  <div className="flex items-center space-x-3">
                    Make sure you are logged in first. Once you in your order review page during checkout, simply click on redeem points button to apply all available points to your order.
                    <br></br>
                    Please refer to this help article for how to redeem your points.
                  </div>
                </div>
              </div>
            </Collapsible>


            <Collapsible trigger="HOW TO UNDERSTAND MY REVIEWS SUMMARY?" open={false} className="mt-2">
              <div className="grid grid-cols-1 xl:grid-cols-1 gap-2 text-sm text-neutral-700 dark:text-neutral-300 max-win-320">
                <div>
                  <div className="flex items-center space-x-3">
                    Make sure you are logged in first. Once you in your order review page during checkout, simply click on redeem points button to apply all available points to your order.
                    <br></br>
                    Please refer to this help article for how to redeem your points.
                  </div>
                </div>
              </div>
            </Collapsible>



            <Collapsible trigger="WHY IS MY REVIEW NOT APPROVED?" open={false} className="mt-2">
              <div className="grid grid-cols-1 xl:grid-cols-1 gap-2 text-sm text-neutral-700 dark:text-neutral-300 max-win-320">
                <div>
                  <div className="flex items-center space-x-3">
                    Make sure you are logged in first. Once you in your order review page during checkout, simply click on redeem points button to apply all available points to your order.
                    <br></br>
                    Please refer to this help article for how to redeem your points.
                  </div>
                </div>
              </div>
            </Collapsible>




            <Collapsible trigger="HOW CAN YOU EARN POINTS FOR REFERRING MY FRIENDS?" open={false} className="mt-2">
              <div className="grid grid-cols-1 xl:grid-cols-1 gap-2 text-sm text-neutral-700 dark:text-neutral-300 max-win-320">
                <div>
                  <div className="flex items-center space-x-3">
                    Make sure you are logged in first. Once you in your order review page during checkout, simply click on redeem points button to apply all available points to your order.
                    <br></br>
                    Please refer to this help article for how to redeem your points.
                  </div>
                </div>
              </div>
            </Collapsible>



            <Collapsible trigger="DO TINYAWAY POINTS EVER EXPIRE?" open={false} className="mt-2">
              <div className="grid grid-cols-1 xl:grid-cols-1 gap-2 text-sm text-neutral-700 dark:text-neutral-300 max-win-320">
                <div>
                  <div className="flex items-center space-x-3">
                    Make sure you are logged in first. Once you in your order review page during checkout, simply click on redeem points button to apply all available points to your order.
                    <br></br>
                    Please refer to this help article for how to redeem your points.
                  </div>
                </div>
              </div>
            </Collapsible>



            <Collapsible trigger="WILL YOU REMIND ME IF MY POINTS ARE ABOUT TO EXPIRE?" open={false} className="mt-2">
              <div className="grid grid-cols-1 xl:grid-cols-1 gap-2 text-sm text-neutral-700 dark:text-neutral-300 max-win-320">
                <div>
                  <div className="flex items-center space-x-3">
                    Make sure you are logged in first. Once you in your order review page during checkout, simply click on redeem points button to apply all available points to your order.
                    <br></br>
                    Please refer to this help article for how to redeem your points.
                  </div>
                </div>
              </div>
            </Collapsible>
          </div>

        </div>
      </div>
    )
  }
  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet title={"Tiny Away | Our Rewards"}></Helmet>
      <div className="bgcolor-light pb-14 pt-10">
        <div className="container">
          <div className="row-profile  mt-5 mb-5">
            <CommonLayout />
            {AccountPageMidSection()}
          </div>
        </div>
      </div>
    </div>
  )
}
export default OurRewords;